<template>
  <div class="primaryFont flex flex-row gap-4">
    <!-- Left Panel (Cards) -->
    <div class="leftPanel">
      <h3 :style="{ color: 'black', fontSize: '24px' }">Efectos Guardados</h3>
      <div class="flex flex-column gap-3">
        <CustomCardEffects
          v-if="effectStore.effectList.length"
          v-for="effect in effectStore.effectList"
          :key="effect.ActuacionEfectoID"
          :effect="getDescriptionEffect(effect)"
          :isSelected="effectStore.isSelected(effect.ActuacionEfectoID)"
          :disabled="effectStore.isCreate || effectStore.isLoading"
          @click="() => handleSelect(effect)"
        />
        <!-- Card simbólica para modo create -->
        <CustomCardEffects
          v-if="effectStore.isCreate && !effectStore.isLoading"
          :key="'create-preview'"
          :effect="getCreatePreviewEffect()"
          :isSelected="true"
          :isPreview="true"
          @click="() => {}"
        />
        <Button
          class="plusButton"
          label="Nuevo Efecto"
          icon="pi pi-plus"
          iconPos="left"
          @click="handleCreate"
          :disabled="effectStore.isCreate || effectStore.isLoading"
        />
      </div>
    </div>
    <!-- Right Panel (Inputs) -->
    <div class="rightPanel secondaryFont">
      <div v-if="!effectStore.effectList.length && !effectStore.isCreate">
        <p class="informativeText secondaryFont">No hay Efecto/s Cargados</p>
      </div>
      <div v-else-if="!effectStore.selectedId && !effectStore.isCreate">
        <p class="informativeText secondaryFont">Seleccione un efecto</p>
      </div>
      <div v-else class="formGrid">
        <div class="inputContainer">
          <label class="labelInput" for="tipoEfecto">
            Tipo Efecto<span style="color: red"> *</span>
          </label>
          <Dropdown
            id="tipoEfecto"
            class="input"
            optionLabel="nombre"
            placeholder="Seleccione estado Efecto"
            :options="typeEffectStore.objetosAllTypes"
            v-model="selectedTypeEffect"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="categoria">
            Categoría<span style="color: red"> *</span>
          </label>
          <Dropdown
            :options="categorias"
            key="CategoriaID"
            placeholder="Seleccione categoría"
            id="categoria"
            class="input"
            optionLabel="Nombre"
            v-model="selectedCategoria"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="subCategoria">
            Sub-Categoría<span style="color: red"> *</span>
          </label>
          <Dropdown
            :options="filteredSubcategorias"
            key="SubcategoriaID"
            placeholder="Seleccione sub - categoría"
            id="subCategoria"
            class="input"
            optionLabel="Nombre"
            v-model="selectedSubcategoria"
            :disabled="effectStore.inputsDisabled || !selectedCategoria"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="tipoSubCategoria">
            Tipo (Sub - Categoría)<span style="color: red"> *</span>
          </label>

          <CustomTooltip
            :text="
              filteredTipoSubcategorias.length === 0
                ? 'ℹ️ No hay tipos disponibles para la subcategoría seleccionada.'
                : null
            "
            :disabled="filteredTipoSubcategorias.length !== 0"
            placement="bottom"
          >
            <Dropdown
              :options="filteredTipoSubcategorias"
              key="tipoID"
              id="tipoSubCategoria"
              placeholder="Seleccione tipo de sub - categoría"
              class="input"
              optionLabel="nombre"
              v-model="selectedTipoSubCategoria"
              :disabled="effectStore.inputsDisabled || filteredTipoSubcategorias.length === 0"
            />
          </CustomTooltip>
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="marca"> Marca<span style="color: red"> *</span> </label>
          <Dropdown
            :options="marcas"
            id="marca"
            placeholder="Seleccione marca"
            class="input"
            optionLabel="nombre"
            v-model="selectedMarca"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="modelo"> Modelo<span style="color: red"> *</span> </label>
          <Dropdown
            :options="modelos"
            id="modelo"
            placeholder="Seleccione modelo"
            class="input"
            optionLabel="Nombre"
            v-model="selectedModelo"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="anio">Año</label>
          <InputText
            v-if="
              effectStore.isView &&
              (effectStore.form.anio === 'Sin Registros' || effectStore.form.anio === '')
            "
            id="anio"
            value="Sin registros"
            class="input"
            :disabled="effectStore.inputsDisabled"
          />
          <InputNumber
            v-else
            id="anio"
            :placeholder="getPlaceholder('anio')"
            class="input"
            v-model="anioNumericValue"
            :disabled="effectStore.inputsDisabled"
            :useGrouping="false"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="nroChasis"> Nro de Chasis </label>
          <InputText
            id="nroChasis"
            :placeholder="getPlaceholder('nroChasis')"
            class="input"
            v-model="nroChasisValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="nroMotor"> Nro Motor </label>
          <InputText
            id="nroMotor"
            class="input"
            :placeholder="getPlaceholder('nroMotor')"
            v-model="nroMotorValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="dominio"> Dominio </label>
          <InputText
            id="dominio"
            class="input"
            :placeholder="getPlaceholder('dominio')"
            v-model="dominioValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="nroSerie"> Nro Serie </label>
          <InputText
            id="nroSerie"
            :placeholder="getPlaceholder('nroSerie')"
            class="input"
            v-no-emoji
            v-model="nroSerieValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="imei">Nro IMEI</label>
          <InputText
            id="imei"
            :placeholder="getPlaceholder('imei')"
            class="input"
            v-model="imeiValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="nroAbonado"> Nro Abonado </label>
          <InputText
            id="nroAbonado"
            :placeholder="getPlaceholder('nroAbonado')"
            class="input"
            v-model="nroAbonadoValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
        <div class="inputContainer">
          <label class="labelInput" for="color">Color</label>
          <InputText
            id="color"
            :placeholder="getPlaceholder('color')"
            class="input"
            v-model="colorValue"
            :disabled="effectStore.inputsDisabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import InputText from "primevue/inputtext/InputText";
import CustomCardEffects from "@/components/CustomCardEffects.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
import { computed, watch, onBeforeMount } from "vue";
import { useStoreCompat } from "@/composables/index";
import { useEffectStore } from "@/store/Pinia/useEffectStore";
import { useTypesEffectStore } from "@/store/Pinia/useTypesEffectStore";

const props = defineProps({
  blockNavigationToAnotherTab: {
    type: Function,
    required: true,
  },
  removeTheBlockNavigationToAnotherTab: {
    type: Function,
    required: true,
  },
});

const store = useStoreCompat();
const effectStore = useEffectStore();
const typeEffectStore = useTypesEffectStore();

const categorias = computed(() => store.state.siis.categoriasDeposito);
const subcategorias = computed(() => store.state.siis.subcategoriasDeposito);
const tipos = computed(() => store.state.siis.tipoDeposito);
const marcas = computed(() => store.state.siis.marca);
const modelos = computed(() => store.state.siis.modelo);

const getPlaceholder = (field) => {
  const originalValue = effectStore.form[field];

  if (effectStore.isView) {
    return "";
  }

  if (originalValue === "Sin Registros" || originalValue === "") {
    return "Sin registro";
  }
  return `Ingrese ${field}`;
};

const anioNumericValue = computed({
  get: () => {
    const value = effectStore.form.anio;
    const numericValue = parseInt(value);
    return isNaN(numericValue) ? null : numericValue;
  },
  set: (value) => {
    effectStore.form.anio = value ? value.toString() : "";
  },
});

const nroChasisValue = computed({
  get: () => {
    const value = effectStore.form.nroChasis;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.nroChasis = value;
  },
});

const nroMotorValue = computed({
  get: () => {
    const value = effectStore.form.nroMotor;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.nroMotor = value;
  },
});

const dominioValue = computed({
  get: () => {
    const value = effectStore.form.dominio;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.dominio = value;
  },
});

const nroSerieValue = computed({
  get: () => {
    const value = effectStore.form.nroSerie;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.nroSerie = value;
  },
});

const imeiValue = computed({
  get: () => {
    const value = effectStore.form.imei;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.imei = value;
  },
});

const nroAbonadoValue = computed({
  get: () => {
    const value = effectStore.form.nroAbonado;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.nroAbonado = value;
  },
});

const colorValue = computed({
  get: () => {
    const value = effectStore.form.color;

    if (effectStore.isView) {
      return value === "Sin Registros" || value === "" ? "Sin registros" : value;
    }

    return value === "Sin Registros" ? "" : value;
  },
  set: (value) => {
    effectStore.form.color = value;
  },
});

const getDescriptionEffect = (effect) => {
  const marca = store.state.siis.marca.find((m) => m.MarcaID === effect.MarcaID);
  const modelo = store.state.siis.modelo.find((m) => m.ModeloID === effect.ModeloID);
  const categoria = store.state.siis.categoriasDeposito.find(
    (c) => c.CategoriaID === effect.CategoriaID
  );
  const subCategoria = store.state.siis.subcategoriasDeposito.find(
    (s) => s.SubcategoriaID === effect.SubcategoriaID
  );
  const tipo = store.state.siis.tipoDeposito.find((t) => t.tipoID === effect.TipoID);

  return {
    marca: marca?.nombre ?? "Sin Marca",
    modelo: modelo?.Nombre ?? "Sin Modelo",
    tipo: tipo?.nombre ?? "Sin Tipo",
    categoria: categoria?.Nombre ?? "Sin Categoría",
    subCategoria: subCategoria?.Nombre ?? "Sin SubCategoría",
    estado: effect.Tipoefecto ?? "Sin Estado",
  };
};

const getCreatePreviewEffect = () => {
  const marca = marcas.value.find((m) => m.MarcaID === effectStore.form.marca);
  const modelo = modelos.value.find((m) => m.ModeloID === effectStore.form.modelo);
  const categoria = categorias.value.find((c) => c.CategoriaID === effectStore.form.categoria);
  const subCategoria = subcategorias.value.find(
    (s) => s.SubcategoriaID === effectStore.form.subCategoria
  );
  const tipo = tipos.value.find((t) => t.tipoID === effectStore.form.tipoSubCategoria);
  const tipoEfecto = typeEffectStore.objetosAllTypes.find(
    (t) => t.id === effectStore.form.tipoEfecto
  );

  return {
    marca: marca?.nombre || "Sin marca",
    modelo: modelo?.Nombre || "Sin modelo",
    tipo: tipo?.nombre || "Sin tipo",
    categoria: categoria?.Nombre || "Sin categoría",
    subCategoria: subCategoria?.Nombre || "Sin sub-categoría",
    estado: tipoEfecto?.nombre || "Sin estado",
  };
};

const handleSelect = (effect) => {
  if (!effectStore.isCreate) {
    effectStore.select(effect);
  }
};

const findOptionById = (options, id, valueKey = "id") => {
  if (!id) return null;
  return options.find((opt) => opt[valueKey] === id) || null;
};

const selectedMarca = computed({
  get: () => findOptionById(marcas.value, effectStore.form.marca, "MarcaID"),
  set: (option) => {
    effectStore.form.marca = option ? option.MarcaID : null;
  },
});

const selectedModelo = computed({
  get: () => findOptionById(modelos.value, effectStore.form.modelo, "ModeloID"),
  set: (option) => {
    effectStore.form.modelo = option ? option.ModeloID : null;
  },
});

const selectedCategoria = computed({
  get: () => findOptionById(categorias.value, effectStore.form.categoria, "CategoriaID"),
  set: (option) => {
    effectStore.form.categoria = option ? option.CategoriaID : null;
  },
});

const selectedSubcategoria = computed({
  get: () => findOptionById(subcategorias.value, effectStore.form.subCategoria, "SubcategoriaID"),
  set: (option) => {
    effectStore.form.subCategoria = option ? option.SubcategoriaID : null;
  },
});

const selectedTipoSubCategoria = computed({
  get: () => findOptionById(tipos.value, effectStore.form.tipoSubCategoria, "tipoID"),
  set: (option) => {
    effectStore.form.tipoSubCategoria = option ? option.tipoID : null;
  },
});

const selectedTypeEffect = computed({
  get: () => findOptionById(typeEffectStore.objetosAllTypes, effectStore.form.tipoEfecto, "id"),
  set: (option) => {
    effectStore.form.tipoEfecto = option ? option.id : null;
  },
});

const filteredSubcategorias = computed(() => {
  if (!selectedCategoria.value) return [];
  return subcategorias.value.filter(
    (sub) => sub.id_categoria === selectedCategoria.value.CategoriaID
  );
});

watch(selectedCategoria, () => {
  if (effectStore.isCreate || effectStore.isEdit) {
    selectedSubcategoria.value = null;
  }
});

const filteredTipoSubcategorias = computed(() => {
  if (!selectedSubcategoria.value) return [];
  return tipos.value.filter(
    (type) => type.id_subcategoria === selectedSubcategoria.value.SubcategoriaID
  );
});

watch(selectedSubcategoria, () => {
  if (effectStore.isCreate || effectStore.isEdit) {
    selectedTipoSubCategoria.value = null;
  }
});

const handleCreate = () => {
  props.blockNavigationToAnotherTab();
  effectStore.startCreate();
};

onBeforeMount(() => {
  store.dispatch("siis/setJuzgados");
  store.dispatch("siis/setMarca");
  store.dispatch("siis/setModelo");
  store.dispatch("siis/setCategoriasDeposito");
  store.dispatch("siis/setSubCategoriasDeposito");
  store.dispatch("siis/setTipoDeposito");
  store.dispatch("siis/setEstadosEfectoDeposito");
  store.dispatch("siis/setEstadosSolicitudDeposito");
});
</script>
<style scoped>
.customCard {
  border-radius: 8px;
  border-left: 6px solid #d97706;
  background-color: #eeeeee;
  box-shadow: 0px 4px 4px 0px #00000040;
  max-width: 448px;
  max-height: 104px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.cardTitle {
  font-weight: 700;
  font-style: bold;
  font-size: 24px;
  color: black;
}

.cardText {
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  color: black;
}

>>> .p-card .p-card-body {
  width: 100% !important;
}

.plusButton {
  background-color: #0b5195;
  border-radius: 6px;
  border: none;
  font-weight: 400;
  font-size: 16px;
}

.plusButton:focus {
  background-color: #0b5195;
  border: none;
}
.plusButton:hover {
  background-color: #0b519580;
  border-radius: 6px;
}

.leftPanel {
  max-width: 448px;
  flex: 1;
}

.rightPanel {
  flex: 2;
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem 2rem;
}

.inputContainer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  max-width: 435px;
}

.labelInput {
  color: #0b5195;
  font-size: 16px;
  font-weight: 400;
}

.input {
  border: 1px solid #0b5195;
  border-radius: 6px;
  width: 100%; /* importante */
  color: #9ca3af;
}

.input:focus {
  border: none !important;
}

.informativeText {
  text-align: center;
  font-size: 28px;
  color: #0b5195;
  font-weight: 500;
}
</style>
